import stylesheet from './TabBarItem.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTTabBarItem extends CustomComponent {
    static observedAttributes = ['selected'];

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get isSelected() {
        return this.hasAttribute('selected');
    }

    render() {
        const element = document.createElement('li');
        if (this.isSelected) {
            element.classList.add('selected');
        }
        element.innerHTML = '<slot></slot>';
        element.tabIndex = 0;
        return element;
    }

    // noinspection JSUnusedGlobalSymbols
    // @ts-ignore
    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        console.log(name, oldValue,newValue)
        if (name === 'selected') {
            this.updateStyles();
        }
    }

    updateStyles() {
        const li = this.shadowRoot.querySelector('li');
        if (this.isSelected) {
            li.classList.add('selected');
        } else {
            li.classList.remove('selected');
        }
    }

}

customElements.define('nxt-tab-bar-item', NXTTabBarItem);
